<template>
	<div class="commonPageSty">
		<sidebar :sidebarType="sidebarType" :sidebarPath="sidebarPath" :isPublicity="isPublicity"></sidebar>

		<div ref="parentRef" class="commonPageRigSty">
			<div class="commonPageTitle">
				设备审批
			</div>

			<div class="commonPageRigBottomSty">
				<publicityContentModal v-if="isPublicity" :propsBackUrlObj="{parUrl: getPathName()}"
					@isHavePublicityContent="isHavePublicityContent"></publicityContentModal>

				<div class="commonPageBack">
					<el-form @submit.native.prevent :model="formData" ref="formDataRef" inline class="formBloSty">
						<div class="displayFSpaceBetween">
							<div class="displayF16Center flex1">
								<div class="positionR input324">
									<el-input @input="searchChange" v-model="formData.keyword"
										placeholder="填写设备名称、申请人ID或编号查询" class="input324"
										prefix-icon="el-icon-search"></el-input>

									<img :src="initThemeImg(theme, 'icon_ss@2x')" alt=""
										class="positionA imgWH16 iconSsImg">
								</div>

								<div>
									<el-form-item label="审批状态">
										<el-select @change="searchChange" v-model="formData.state" placeholder="请选择"
											clearable class="input224">
											<el-option v-for="item in stateData" :key="item.id" :label="item.name"
												:value="item.id" />
										</el-select>
									</el-form-item>
								</div>
							</div>

							<div class="displayF">
								<!-- :class="isGetPermission() && archiveConfigData.exportDeviceApply ? '' : 'opacity05'" -->
								<el-button @click="exportHandle()" type="primary" :loading="loading">导出</el-button>
								<!-- :class="isGetPermission() ? '' : 'opacity05'" -->
								<el-button @click="passThroughAndRejectHandle(1)" type="primary">通过</el-button>
								<!-- :class="isGetPermission() ? '' : 'opacity05'" -->
								<el-button @click="passThroughAndRejectHandle(2)" type="danger">否决</el-button>
							</div>
						</div>
					</el-form>
				</div>

				<div class="commonPageBack commonPageBackBottom24">
					<el-table @selection-change="handleSelectionChange" :data="tableData" type="selection"
						:height="isHave ? 'calc(100vh - 318px)' : 'calc(100vh - 270px)'" tooltip-effect="light">
						<template #empty>
							<el-empty v-if="!tableData.length" :image="theme == 'dark' ? tableNoDataDark : tableNoData"
								description="暂无数据"></el-empty>
						</template>
						<el-table-column type="selection" width="40" align="left"></el-table-column>
						<el-table-column v-for="(item, i) in props" :key="i" :prop="item.prop" :label="item.name"
							:show-overflow-tooltip="true">
							<template #default="scope">
								<div v-if="item.prop == 'state'" :class="approvalStatusClass(scope.row[item.prop])">
									{{approvalStatusText(scope.row[item.prop]) || '-'}}
								</div>
								<div v-else-if="item.prop == 'createTime'" class="color_B9B ellipsisSty">
									{{scope.row[item.prop] ? scope.row[item.prop].substring(0, 16) : '-' }}
								</div>
								<div v-else class="color_B9B ellipsisSty">
									{{scope.row[item.prop] || '-' }}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" min-width="48">
							<template #default="scope">
								<!-- :class="isGetPermission() ? '' : 'opacity05'" -->
								<el-button @click="detailsHandle(scope.row)" type="text">详情</el-button>
							</template>
						</el-table-column>
					</el-table>

					<div class="paginationBlo marginB8 padding16_40">
						<div class="total">
							共 {{total}} 条数据
						</div>
						<Pagination :page="page" :pageSize="pageSize" :total="total" @pagination="paginationHandle">
						</Pagination>
					</div>
				</div>
			</div>
		</div>

		<!-- 二次确认弹窗 -->
		<tipModal v-if="state" :text="text" :loadingReset="loadingReset" @sureHandle="archivedeviceapplyAuthorizeApi"
			@cancelHandle="state = null"></tipModal>
		<approvalModal v-if="approvalModalShow" :propsObj="commonModalObj" @sureHandle="archivedeviceapplyAuthorizeApi"
			@cancelHandle="approvalModalShow = false"></approvalModal>
	</div>
</template>

<script setup>
	// import tableNoData from '@/assets/imgs/bright/icon-nodata@2x.png'
	import tableNoDataDark from '@/assets/imgs/dark/icon-nodata@2x.png'
	import {
		getPathName,
		downMethods,
		initThemeImg,
		jumpUrlConfig,
		setMessageQueue,
		isGetPermission,
		getNotEditableShow,
		approvalStatusText,
		approvalStatusClass,
		globalCacheQueryApi,
		cacheUpdateCacheTypeApi,
		globalCacheSaveWhereNowApi
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'
	import sidebar from '@/components/sidebar'

	import {
		archivedeviceapplyInfo,
		archivedeviceapplyList,
		archivedeviceapplyAuthorize,
		archivedeviceapplyDownloadCustomize
	} from '@/api/archivePage'

	// ***添加name keep-alive--include 才生效
	defineOptions({
		name: 'EquipmentApproval'
	})

	const router = useRouter()
	const route = useRoute()

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	// 获取自定义配置
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})
	// 获取档案库配置
	const archiveConfigData = computed(() => {
		return useUserStore().archiveConfigData
	})

	const sidebarType = ref('archive')
	const sidebarPath = '/' + getPathName()
	const formData = ref({
		state: '',
		keyword: '',
	})
	const stateData = ref([{
		id: 1,
		name: '审核中'
	}, {
		id: 2,
		name: '通过'
	}, {
		id: 3,
		name: '否决'
	}]) // 审批状态数据
	const page = ref(1)
	const pageSize = ref(20)
	const total = ref(0)
	const props = ref([{
		name: '编号',
		prop: 'applyCode'
	}, {
		name: '申请设备名称',
		prop: 'deviceName'
	}, {
		name: '使用时间',
		prop: 'useTime'
	}, {
		name: '申请时间',
		prop: 'createTime'
	}, {
		name: '审核状态',
		prop: 'state'
	}, {
		name: '申请人',
		prop: 'applyUserInfo'
	}])
	const tableData = ref([]) // 列表数据
	const multipleSelection = ref([])
	const state = ref(null) // 审核状态
	const approvalModalShow = ref(false) // 审批弹窗
	const text = ref('')
	const commonModalObj = ref({})
	const isPublicity = ref(false)
	const rowId = ref('')
	const loadingReset = ref(false) // 20260302 新增 报错时重置loading状态 报错时true/false提交时
	const loading = ref(false)

	const isHave = ref(false)

	// 是否有公示数据
	function isHavePublicityContent(val) {
		isHave.value = val
	}

	// 点击选中
	function handleSelectionChange(val) {
		multipleSelection.value = val;
	}

	// 导出
	async function exportHandle() {
		// if (!archiveConfigData.value.exportDeviceApply) {
		// 	setMessageQueue('warning', '无法导出，设备审核导出许可关闭中')
		// 	return
		// }

		if (multipleSelection.value.length === 0) {
			setMessageQueue('warning', '未指定设备')
			return
		} else {
			const data = await getNotEditableShow('', '', 8)
			if (data.code === 505) {
				return
			}

			if (loading.value) {
				return
			}

			loading.value = true

			// 导出
			archivedeviceapplyDownloadCustomizeApi()
		}
	}

	// 导出
	function archivedeviceapplyDownloadCustomizeApi() {
		let ids = []
		let arr = multipleSelection.value || []
		if (arr.length > 0) {
			arr.map(item => {
				ids.push(item.applyId)
			})
		}

		archivedeviceapplyDownloadCustomize({
			ids
		}).then(res => {
			if (res) {
				loading.value = false
				downMethods(res)
				setMessageQueue('success', '已加入导出队列，详细查看‘导出记录’')
			}
		}).catch(e => {
			loading.value = false
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 点击通过/否决
	async function passThroughAndRejectHandle(type) {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }
		const data = await getNotEditableShow('', '', 1)
		if (data.code === 505) {
			return
		}

		let length = multipleSelection.value.length
		if (length === 0) {
			setMessageQueue('warning', '未指定设备')
			return
		} else {
			for (let i = 0; i < length; i++) {
				if (multipleSelection.value[i].state !== 1) {
					setMessageQueue('warning', '请选择审核中的设备')
					return
				}
			}
		}
		state.value = type
		text.value = '是否' + (type === 1 ? '通过' : '否决') + '勾选设备申请？'
	}

	// 通过/否决
	function archivedeviceapplyAuthorizeApi(val) {
		let ids = []
		if (multipleSelection.value.length > 0 && !val) {
			multipleSelection.value.map(item => {
				ids.push(item.applyId)
			})
		}
		let stateParams = val || state.value

		// 20260302 新增 报错时重置loading状态 报错时true/false提交时
		loadingReset.value = false
		// 20260303 新增 报错时重置loading状态
		loadingResetMethods(false)

		archivedeviceapplyAuthorize({
			applyId: val ? [rowId.value] : ids,
			state: stateParams // 审批，1表示通过、2表示否决
		}).then(res => {
			if (res) {
				state.value = null
				approvalModalShow.value = false
				// 刷新
				searchChange()
				setMessageQueue('success', '设备申请审批已' + (stateParams === 1 ? '通过' : '否决'))
				// 获取设备审核中数量
				useUserStore().archivedeviceapplyApprovalNumApi()
			}
		}).catch(e => {
			// 20260302 新增 报错时重置loading状态 报错时true/false提交时
			loadingReset.value = true
			// 20260303 新增 报错时重置loading状态
			loadingResetMethods(true)
			setMessageQueue('error', e)
			console.log(e)
		})
	}
	
	// 20260303 新增 报错时重置loading状态 报错时true/false提交时
	function loadingResetMethods(val) {
		commonModalObj.value.loadingReset = val
	}
	
	// 筛选/刷新
	function searchChange() {
		page.value = 1
		// 获取列表数据
		getListData()
	}

	// 点击进入详情(管理员)
	async function detailsHandle(row) {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }
		const data = await getNotEditableShow('', '', 1)
		if (data.code === 505) {
			return
		}

		// 跳转前 查询当前详情页数据是否还在
		archivedeviceapplyInfoApi(row)
	}

	// 跳转前 查询当前详情页数据是否还在
	function archivedeviceapplyInfoApi(row) {
		archivedeviceapplyInfo({
			id: row.applyId
		}).then(res => {
			if (res) {
				// 根据当前审核状态判断  审核中展示弹窗、通过/驳回展示页面
				if (row.state === 1) {
					rowId.value = row.applyId
					approvalModalShow.value = true
					commonModalObj.value = {
						title: '审批详情',
						data: row.applyId
					}
				} else {
					let readModel = userConfigData.value.readModel
					let url = '/equipmentApprovalDetails?id=' + row.applyId

					if (readModel === 'newPage') {
						jumpUrlConfig(url, getPathName())
					} else {
						router.push(url)
					}

					// // 根据自定义配置--阅读模式 来跳转页面并传参设备applyId
					// jumpUrlConfig('/equipmentApprovalDetails?id=' + row.applyId, getPathName())
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 点击切换分页
	function paginationHandle(val) {
		page.value = val.page
		pageSize.value = val.pageSize
		// 获取列表数据
		getListData()
	}

	// 获取列表数据
	function getListData(init) {
		let params = {
			page: page.value,
			limit: pageSize.value,
		}
		params = {
			...params,
			...formData.value
		}
		archivedeviceapplyList(params).then(res => {
			if (res) {
				let data = res.data
				tableData.value = data.list
				total.value = data.totalCount

				if (init) {
					// 更新设备审批缓存（确认已经缓存）
					console.log(cacheUpdateCacheTypeApi('archive_device_approve_type'))
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	watch(() => router, val => {
		// console.log(useUserStore().cachedViews, 'cachedViews')

		if (useUserStore().cachedViews.length > 0) {
			// 当前页时 
			if (route.path === '/equipmentApproval') {
				// 初始化公共方法
				initMethods()

				// 获取缓存状态（档案库-设备审批）
				useUserStore().cacheGetCacheTypeApi('archive_device_approve_type').then((res) => {
					if (res) {
						page.value = 1
						formData.value = {
							state: '',
							keyword: '',
						}
						// 获取初始化列表数据
						getListData('init')
					}
				})
			}
		}
	}, {
		deep: true,
		immediate: true
	})

	// 初始化公共方法
	async function initMethods(init) {
		if (!init) {
			sidebarType.value = ''
			setTimeout(() => {
				sidebarType.value = 'archive'
			})
		}
		// 初始化当前的展开菜单
		useUserStore().sidebarType = 'archive'
		// 获取设备审核中数量
		useUserStore().archivedeviceapplyApprovalNumApi()

		const routeData = await globalCacheSaveWhereNowApi(route.path.replace('/', ''))
		console.log(routeData, 'globalCacheSaveWhereNowApi')

		if (routeData.code === 200) {
			// 查询详情页路径缓存
			const res = await globalCacheQueryApi('device_approve')
			if (res && res.data.length > 0) {
				let data = res.data
				router.push(data[0].redirectPath)
				console.log(data, 'res.data')
			}
			// console.log(useUserStore().sidebarType, useUserStore().defaultOpeneds, 'initMethods eaea')
		}

		isPublicity.value = false
		setTimeout(() => {
			isPublicity.value = true
		})
	}

	onMounted(() => {
		// 初始化公共方法
		initMethods('init')

		// 获取初始化列表数据
		getListData('init')
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.el-form-item--default {
		margin-bottom: 0 !important;
	}
</style>